// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sec_sp {
    margin-bottom: calc(3rem + 5.128vw)
}

.table td,
.table th {
    color: var(--text-color);
}

.t_border {
    border-color: var(--text-color) !important;
}

.progress-title {
    font-size: 16px;
    font-weight: 700;
    margin: 15px 0 20px;
    font-family: 'Raleway';
}

.progress {
    height: 5px;
    background: var(--secondary);
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 30px;
    overflow: visible;
}

.progress .progress-bar {
    position: relative;
    background: var(--text-color);
    animation: animate-positive 2s;
    overflow: visible;
    opacity: 0.9;
}

.progress .progress-value {
    position: absolute;
    top: -30px;
    right: 8px;
    font-size: 24px;
    font-weight: bold;
    font-style: italic;
    color: var(--text-color);
}

@keyframes animate-positive {
    0% {
        width: 0%;
    }
}

.section-title {
    font-size: 45px;
}

.service__title {
    padding: 8px 0;
    border-bottom: solid 2px var(--secondary-color);
}

.service-section .service-category-title {
    padding-bottom: 4px;
}


/*! CSS Used keyframes */

@keyframes fadeInUp {
    0% {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/about/style.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAQA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;AACvB;;;AAGA,wBAAwB;;AAexB;IACI;QACI,UAAU;QAEV,kCAAkC;IACtC;IACA;QACI,UAAU;QAEV,wBAAwB;IAC5B;AACJ","sourcesContent":[".sec_sp {\n    margin-bottom: calc(3rem + 5.128vw)\n}\n\n.table td,\n.table th {\n    color: var(--text-color);\n}\n\n.t_border {\n    border-color: var(--text-color) !important;\n}\n\n.progress-title {\n    font-size: 16px;\n    font-weight: 700;\n    margin: 15px 0 20px;\n    font-family: 'Raleway';\n}\n\n.progress {\n    height: 5px;\n    background: var(--secondary);\n    border-radius: 0;\n    box-shadow: none;\n    margin-bottom: 30px;\n    overflow: visible;\n}\n\n.progress .progress-bar {\n    position: relative;\n    background: var(--text-color);\n    animation: animate-positive 2s;\n    overflow: visible;\n    opacity: 0.9;\n}\n\n.progress .progress-value {\n    position: absolute;\n    top: -30px;\n    right: 8px;\n    font-size: 24px;\n    font-weight: bold;\n    font-style: italic;\n    color: var(--text-color);\n}\n\n@-webkit-keyframes animate-positive {\n    0% {\n        width: 0%;\n    }\n}\n\n@keyframes animate-positive {\n    0% {\n        width: 0%;\n    }\n}\n\n.section-title {\n    font-size: 45px;\n}\n\n.service__title {\n    padding: 8px 0;\n    border-bottom: solid 2px var(--secondary-color);\n}\n\n.service-section .service-category-title {\n    padding-bottom: 4px;\n}\n\n\n/*! CSS Used keyframes */\n\n@-webkit-keyframes fadeInUp {\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n    }\n    to {\n        opacity: 1;\n        -webkit-transform: translateZ(0);\n        transform: translateZ(0);\n    }\n}\n\n@keyframes fadeInUp {\n    0% {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 100%, 0);\n        transform: translate3d(0, 100%, 0);\n    }\n    to {\n        opacity: 1;\n        -webkit-transform: translateZ(0);\n        transform: translateZ(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
